import React from "react";

export interface HeaderProps {
  title: string;
  icon?: string;
  meta?: React.ReactNode;
}

const Header = ({ icon, title, meta }: HeaderProps) => {
  // Treat "N/A" as null for icon
  const validIcon = icon && icon !== "N/A" ? icon : null;
  const nothing = !validIcon && !title && !meta;
  const iconOrTitle = validIcon || title;
  if (nothing) return <></>;

  return (
    <div className="w-full flex justify-between items-center gap-2 pb-[6px]">
      <div className="flex-1 flex justify-start items-center gap-2 min-w-0">
        {iconOrTitle && (
          <>
            <div className="flex flex-col justify-between items-center w-[26px] h-[26px] flex-shrink-0 rounded-[8px] squircle-mask squircle-radius-[8px] overflow-hidden">
              {validIcon ? (
                <img
                  src={validIcon}
                  alt="Creative Account Icon"
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full rounded-[8px] bg-[#E8E8E8] flex items-center justify-center text-brand-primary-new text-sm font-medium">
                  <span className="relative top-[1px]">
                    {title?.[0]?.toUpperCase() ?? ""}
                  </span>
                </div>
              )}
            </div>
            {title && (
              <span className="flex-1 truncate text-brand-primary-new text-[12px] font-normal leading-[18px] tracking-[0.28px] min-w-0">
                {title}
              </span>
            )}
          </>
        )}
      </div>
      {meta && <div className="flex-shrink-0">{meta}</div>}
    </div>
  );
};

export default Header;
